import { makeAutoObservable } from "mobx";
import getLocation from "../../../utilities/helpers/GetLocationHelper";
import { storageService } from "../../../utilities/service/StorageService";
import { supabase } from "../../../utilities/service/SupabaseConnector";
class HeaderState{
    locationInfo: any = null;
    selectedMainMenuItem: string = '';
    orderedDishAmount: string = '';
    loginStatus: boolean = false;
    amount: number = 0; //Just use to make sure the header changes!
    constructor(){
        makeAutoObservable(this);
    }
    async handleLocationGetting(){
        this.locationInfo = await getLocation();
    }
    handleSelectedItemMenu(itemValue: string){
        storageService.setSelectedItemInMainMenu(itemValue)
        this.selectedMainMenuItem = itemValue;
    }
    logOutAction(){
        this.loginStatus = false;
        storageService.deleteAllDataInStorage();
    }
    async checkLoginStatus(){
        const accessToken = storageService.getAccessToken();
        if(accessToken){
            const {data: user, error} = await supabase.auth.getUser(accessToken);
            if(error){
                this.loginStatus = false;
                storageService.deleteAccessToken()
                storageService.deleteRefreshToken()
            }
            else{
                this.loginStatus = true;
            }
        }
    }
}
export const headerState = new HeaderState();